import React from 'react';
import styled from 'styled-components';
import Radio from '../../assets/icons/radio_button.svg';
import RadioCheckedNormal from '../../assets/icons/radio_button_checked.svg';
import RadioCheckedBlue from '../../assets/icons/radio_button_checked_blue.svg';
import RadioCheckedBlueLight from '../../assets/icons/radio_button_checked_blueVA.svg';
import RadioCheckedGreenUB from '../../assets/icons/radio_button_checked_UB.svg';
import { getSite } from '../../../leads/src/services/utils/leads';

function RadioChecked() {
  const site = getSite();
  switch (site) {
    case 'CMBR':
      return RadioCheckedBlue;
    case 'VAMX':
      return RadioCheckedBlueLight;
    case 'UBPE':
      return RadioCheckedGreenUB;
    default:
      return RadioCheckedNormal;
  }
}

const RadioButton = ({ name, checked, onChange, dataPanel, labelText }) => (
  <RadioContainer>
    <HiddenRadio name={name} checked={checked} onChange={onChange} />
    <StyledRadio checked={checked} data-panel={dataPanel} onClick={onChange} />
    {labelText && <StyledLabel onClick={onChange}>{labelText}</StyledLabel>}
  </RadioContainer>
);

const RadioContainer = styled.div`
  display: flex;
  align-items: center;
`;

const HiddenRadio = styled.input.attrs({ type: 'radio' })`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

const StyledRadio = styled.div`
  display: inline-block;
  width: 18px;
  height: 16px;
  background-image: ${({ checked }) => (checked ? `url(${RadioChecked()})` : `url(${Radio})`)};
  background-repeat: no-repeat;
  background-size: contain;
  cursor: pointer;
`;

const StyledLabel = styled.label`
  cursor: pointer;
  display: flex;
  align-items: center;
  font-family: Hind;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: left;
  margin-left: 1rem;
  white-space: pre-wrap;
`;

export default RadioButton;
